import { QuestionnaireResponseItemAnswer } from '@medplum/fhirtypes'
import dayjs from 'dayjs'
import {
  SharedCareQuestionnaireItem,
  SharedCareQuestionnaireItemType
} from 'components/Assessments/hooks/constants'
import {
  createAnswerItemsFromValues,
  getAnswerValuesFromItems
} from 'components/Assessments/helpers'
import { ADLNeed, ADLNeedTemplate } from './types'

export const mapAssessmentADLItemIntoADLNeeds = (
  adlItemAnswer: QuestionnaireResponseItemAnswer[],
  adlNeeds?: ADLNeedTemplate[]
): ADLNeed[] => {
  return adlItemAnswer.map((adlInfoAnswerItem): ADLNeed => {
    const interventionInfoItem = adlInfoAnswerItem.item ?? []

    const [
      [id],
      [observationReference],
      [name],
      [newNote],
      [isArchived],
      [lastNoteAuthor],
      [lastNoteDate],
      [lastNoteText]
    ] = [
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_ID'),
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_OBSERVATION_REFERENCE'),
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_NAME'),
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_NEW_NOTE'),
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_IS_ARCHIVED'),
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_LAST_NOTE_AUTHOR'),
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_LAST_NOTE_DATE'),
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_LAST_NOTE_TEXT')
    ].map((linkId) => getAnswerValuesFromItems(interventionInfoItem, linkId))

    return {
      id,
      name: name,
      observationReference: observationReference,
      newNote: newNote,
      isArchived: isArchived,
      isLegacy: adlNeeds?.find((adl) => adl.id === id)?.isLegacy ?? undefined,
      lastNoteAuthor: lastNoteAuthor,
      lastNoteDate: lastNoteDate ? dayjs(lastNoteDate) : undefined,
      lastNoteText: lastNoteText
    }
  })
}

export const adlToRawItemAnswer = (adlNeed: ADLNeed): QuestionnaireResponseItemAnswer => {
  const questionnaireItemsAndValues: [SharedCareQuestionnaireItemType, unknown][] = [
    [SharedCareQuestionnaireItem('ADL_NEEDS_NEED_ID'), adlNeed.id.toString()],
    [
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_OBSERVATION_REFERENCE'),
      adlNeed?.observationReference
    ],
    [SharedCareQuestionnaireItem('ADL_NEEDS_NEED_NAME'), adlNeed.name],
    [SharedCareQuestionnaireItem('ADL_NEEDS_NEED_NEW_NOTE'), adlNeed?.newNote],
    [SharedCareQuestionnaireItem('ADL_NEEDS_NEED_IS_ARCHIVED'), adlNeed.isArchived],
    [SharedCareQuestionnaireItem('ADL_NEEDS_NEED_LAST_NOTE_AUTHOR'), adlNeed?.lastNoteAuthor],
    [
      SharedCareQuestionnaireItem('ADL_NEEDS_NEED_LAST_NOTE_DATE'),
      adlNeed?.lastNoteDate?.toISOString()
    ],
    [SharedCareQuestionnaireItem('ADL_NEEDS_NEED_LAST_NOTE_TEXT'), adlNeed?.lastNoteText]
  ]
  return {
    item: createAnswerItemsFromValues(questionnaireItemsAndValues)
  } as QuestionnaireResponseItemAnswer
}
